(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["erzieherwissen-app-landingpage"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var selector = '[data-ew-lumano-landingpage]';
    var activeTimers = new WeakMap();

    function initBrevo() {
      window.REQUIRED_CODE_ERROR_MESSAGE = 'Wähle bitte eine Ländervorwahl aus.';
      window.LOCALE = 'de';
      window.EMAIL_INVALID_MESSAGE = window.SMS_INVALID_MESSAGE = 'Bitte gib eine gültige E-Mail-Adresse ein.';
      window.REQUIRED_ERROR_MESSAGE = 'Dieses Feld darf nicht leer sein.';
      window.GENERIC_INVALID_MESSAGE = 'Bitte überprüfe deine Eingabe und versuche es erneut.';
      window.INVALID_NUMBER = 'Bitte überprüfe deine Eingabe und versuche es erneut.';
      window.INVALID_DATE = 'Bitte gib ein gültiges Datum ein.';
      window.REQUIRED_MULTISELECT_MESSAGE = 'Wähle bitte mindestens eine Option aus.';
      window.translation = {
        common: {
          selectedList: '{quantity} Liste ausgewählt',
          selectedLists: '{quantity} Listen ausgewählt',
          selectedOption: '{quantity} ausgewählt',
          selectedOptions: '{quantity} ausgewählt'
        }
      };
      window.AUTOHIDE = false;

      var source = 'https://sibforms.com/forms/end-form/build/main.js';
      if (document.querySelector('script[src="' + source + '"]')) return;

      var script = document.createElement('script');
      script.src = source;
      script.defer = true;
      script.dataset.ewBrevoFormScript = 'true';
      document.head.appendChild(script);
    }

    function findRoot(target) {
      if (!target) return null;
      if (target.matches && target.matches(selector)) return target;
      return target.querySelector ? target.querySelector(selector) : null;
    }

    function initCountdown(root) {
      var wrap = root.querySelector('[data-ew-lumano-countdown]');
      var timerElement = root.querySelector('[data-ew-lumano-timer]');
      var completeElement = root.querySelector('[data-ew-lumano-complete]');
      var endValue = root.dataset.launchEnd;

      if (!wrap || !timerElement || !endValue) return;

      var endTime = Date.parse(endValue);
      if (Number.isNaN(endTime)) {
        wrap.hidden = true;
        return;
      }

      var parts = {
        days: root.querySelector('[data-ew-lumano-time="days"]'),
        hours: root.querySelector('[data-ew-lumano-time="hours"]'),
        minutes: root.querySelector('[data-ew-lumano-time="minutes"]'),
        seconds: root.querySelector('[data-ew-lumano-time="seconds"]')
      };

      var intervalId;

      function setPart(element, value) {
        var output = String(value);
        if (output.length < 2) output = '0' + output;
        if (element) element.textContent = output;
      }

      function render() {
        var remaining = Math.max(0, endTime - Date.now());
        var days = Math.floor(remaining / 86400000);
        var hours = Math.floor((remaining % 86400000) / 3600000);
        var minutes = Math.floor((remaining % 3600000) / 60000);
        var seconds = Math.floor((remaining % 60000) / 1000);

        setPart(parts.days, days);
        setPart(parts.hours, hours);
        setPart(parts.minutes, minutes);
        setPart(parts.seconds, seconds);

        if (remaining === 0) {
          timerElement.hidden = true;
          if (completeElement) completeElement.hidden = false;
          if (intervalId) window.clearInterval(intervalId);
          activeTimers.delete(root);
          return false;
        }

        return true;
      }

      if (render()) {
        intervalId = window.setInterval(render, 1000);
        activeTimers.set(root, intervalId);
      }
    }

    function initFaq(root) {
      var items = Array.prototype.slice.call(root.querySelectorAll('.ew-lumano-lp__faq-item'));
      items.forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (!item.open) return;
          items.forEach(function (other) {
            if (other !== item) other.open = false;
          });
        });
      });
    }

    function initLandingpage(root) {
      if (!root || root.dataset.ewLumanoInitialized === 'true') return;
      root.dataset.ewLumanoInitialized = 'true';
      initCountdown(root);
      initFaq(root);
      initBrevo();
    }

    Array.prototype.forEach.call(document.querySelectorAll(selector), initLandingpage);

    document.addEventListener('shopify:section:load', function (event) {
      initLandingpage(findRoot(event.target));
    });

    document.addEventListener('shopify:section:unload', function (event) {
      var root = findRoot(event.target);
      var intervalId = root ? activeTimers.get(root) : null;
      if (intervalId) window.clearInterval(intervalId);
      if (root) activeTimers.delete(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["erzieherwissen-app"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-lumano-announcement]';
    const activeTimers = new WeakMap();

    const findRoot = (target) => {
      if (!target) return null;
      if (target.matches && target.matches(selector)) return target;
      return target.querySelector ? target.querySelector(selector) : null;
    };

    const initCountdown = (root) => {
      if (!root || root.dataset.lumanoCountdownInitialized === 'true') return;
      root.dataset.lumanoCountdownInitialized = 'true';

      const countdownCard = root.querySelector('[data-lumano-countdown]');
      const timerElement = root.querySelector('[data-lumano-timer]');
      const completeElement = root.querySelector('[data-lumano-countdown-complete]');
      const endValue = root.dataset.launchEnd;

      if (!countdownCard || !timerElement || !endValue) return;

      const endTime = Date.parse(endValue);
      if (Number.isNaN(endTime)) {
        countdownCard.hidden = true;
        return;
      }

      const parts = {
        days: root.querySelector('[data-lumano-time="days"]'),
        hours: root.querySelector('[data-lumano-time="hours"]'),
        minutes: root.querySelector('[data-lumano-time="minutes"]'),
        seconds: root.querySelector('[data-lumano-time="seconds"]')
      };

      let intervalId;

      const setPart = (element, value) => {
        if (element) element.textContent = String(value).padStart(2, '0');
      };

      const render = () => {
        const remaining = Math.max(0, endTime - Date.now());
        const days = Math.floor(remaining / 86400000);
        const hours = Math.floor((remaining % 86400000) / 3600000);
        const minutes = Math.floor((remaining % 3600000) / 60000);
        const seconds = Math.floor((remaining % 60000) / 1000);

        setPart(parts.days, days);
        setPart(parts.hours, hours);
        setPart(parts.minutes, minutes);
        setPart(parts.seconds, seconds);

        if (remaining === 0) {
          timerElement.hidden = true;
          if (completeElement) completeElement.hidden = false;
          if (intervalId) window.clearInterval(intervalId);
          activeTimers.delete(root);
          return false;
        }

        return true;
      };

      if (render()) {
        intervalId = window.setInterval(render, 1000);
        activeTimers.set(root, intervalId);
      }
    };

    document.querySelectorAll(selector).forEach(initCountdown);

    document.addEventListener('shopify:section:load', (event) => {
      initCountdown(findRoot(event.target));
    });

    document.addEventListener('shopify:section:unload', (event) => {
      const root = findRoot(event.target);
      const intervalId = root ? activeTimers.get(root) : null;
      if (intervalId) window.clearInterval(intervalId);
      if (root) activeTimers.delete(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["erzieherwissen-early-access"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initEarlyAccess = (root) => {
      if (!root || root.dataset.ewInitialized === 'true') return;
      root.dataset.ewInitialized = 'true';

      const endValue = root.dataset.offerEnd;
      if (!endValue) return;

      const endTime = new Date(endValue).getTime();
      if (Number.isNaN(endTime)) return;

      const parts = {
        days: root.querySelector('[data-ew-time="days"]'),
        hours: root.querySelector('[data-ew-time="hours"]'),
        minutes: root.querySelector('[data-ew-time="minutes"]'),
        seconds: root.querySelector('[data-ew-time="seconds"]')
      };
      const button = root.querySelector('[data-ew-cta]');
      const expiredMessage = root.querySelector('[data-ew-expired]');
      let timer;

      const render = () => {
        const remaining = Math.max(0, endTime - Date.now());
        const days = Math.floor(remaining / 86400000);
        const hours = Math.floor((remaining % 86400000) / 3600000);
        const minutes = Math.floor((remaining % 3600000) / 60000);
        const seconds = Math.floor((remaining % 60000) / 1000);

        if (parts.days) parts.days.textContent = String(days).padStart(2, '0');
        if (parts.hours) parts.hours.textContent = String(hours).padStart(2, '0');
        if (parts.minutes) parts.minutes.textContent = String(minutes).padStart(2, '0');
        if (parts.seconds) parts.seconds.textContent = String(seconds).padStart(2, '0');

        if (remaining === 0) {
          root.dataset.expired = 'true';
          if (button) {
            button.disabled = true;
            button.textContent = root.dataset.expiredText;
          }
          if (expiredMessage) expiredMessage.hidden = false;
          if (timer) window.clearInterval(timer);
        }
      };

      render();
      timer = window.setInterval(render, 1000);
    };

    document.querySelectorAll('[data-ew-early-access]').forEach(initEarlyAccess);
    document.addEventListener('shopify:section:load', (event) => {
      initEarlyAccess(event.target.querySelector('[data-ew-early-access]'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
